import React, {FC} from 'react';

export function ResetPassword() {
    return <div>Reset Password</div>
}